import React, { createContext, useContext, useState } from "react";
import { createPortal } from "react-dom";

const CollectionChrome = createContext(null);
const RecordChrome = createContext(null);
export const SidebarChromeContext = createContext(false);
export function CollapsedRecordSection({ label }) {
  const collapsed = useContext(SidebarChromeContext);
  return collapsed ? <span className="one-row-section-label one-row-record-section" data-testid="collapsed-section-label">{label}</span> : null;
}

// Hosts move presentation only: routed pages retain tab state and callbacks.
export function CollectionChromeProvider({ children, reportChrome = false }) {
  const [host, setHost] = useState(null);
  return <CollectionChrome.Provider value={{ host, setHost, reportChrome }}>{children}</CollectionChrome.Provider>;
}
export function useUnifiedReportChrome() { return useContext(CollectionChrome)?.reportChrome === true; }
export function CollectionNavigationHost() {
  const chrome = useContext(CollectionChrome);
  return <div className="one-row-navigation-host" ref={chrome?.setHost} />;
}
export function CollectionNavigation({ children }) {
  const chrome = useContext(CollectionChrome);
  return chrome ? (chrome.host ? createPortal(children, chrome.host) : null) : children;
}
export function RecordLayout({ children, ...props }) {
  const [back, setBack] = useState(null);
  const [actions, setActions] = useState(null);
  return <RecordChrome.Provider value={{ back, setBack, actions, setActions }}>
    <div {...props} data-one-row-record>{children}</div>
  </RecordChrome.Provider>;
}
export function RecordBackHost({ backLabel, onBack, testId, sectionLabel }) {
  const chrome = useContext(RecordChrome);
  if (backLabel) return <><CollapsedRecordSection label={sectionLabel ?? backLabel} /><div className="one-row-record-back">
    <button className="one-row-back-link" data-testid={testId} onClick={onBack}>‹ {backLabel}</button>
  </div></>;
  return chrome ? <div className="one-row-record-back" ref={chrome.setBack} /> : null;
}
export function RecordActionsHost() {
  const chrome = useContext(RecordChrome);
  return chrome ? <div className="one-row-record-actions object-record-actions" ref={chrome.setActions} /> : null;
}
export function RecordNavigationPortal({ back, actions }) {
  const chrome = useContext(RecordChrome);
  return <>{chrome?.back && createPortal(back, chrome.back)}{chrome?.actions && createPortal(actions, chrome.actions)}</>;
}
